import Joi from "joi";

const loginSchema = {
  // #107. TLD is {2,63}, not {2,5}: `.digital`, `.online`, `.technology` are
  // ordinary registrar TLDs and RFC 1035 allows a 63-character label, so the
  // short cap locked real addresses out of the form. Must stay identical to
  // signupSchema's rule and to the server's — see
  // react-app/src/users/models/Joi/emailPattern.test.js and
  // server/__tests__/emailValidationParity.test.js, which assert that. The
  // local part still refuses `+`: the owner decided on 2026-10-11 to keep it
  // that way (one inbox must not mint many accounts).
  email: Joi.string()
    .ruleset.pattern(/^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,63})$/)
    // B-24. The same words as the sign-up form, not Joi's 'user "mail" ...'.
    .rule({ message: "Enter a valid email address, like name@example.com" })
    .required()
    .messages({
      "string.empty": "Enter your email address",
      "any.required": "Enter your email address",
    }),

  // Presence only — deliberately NOT the signup complexity rule.
  //
  // This form authenticates a password that already exists somewhere else, so
  // re-deriving the registration policy over it can only ever produce a false
  // negative: it cannot turn a wrong password into a right one, and the one
  // thing it reliably does is reject correct credentials whose password was set
  // outside this app's signup form. That is not a hypothetical — the documented
  // beta onboarding path is to invite the tester in the Supabase dashboard
  // (docs/BETA_READINESS_CHECKLIST.md), where nothing enforces our character
  // classes, so every such tester was locked out by a client-side message
  // telling them their correct password was malformed, with the sign-in request
  // never sent. Check the field is filled in, then let the server answer.
  //
  // (The email rule above was the separate backlog item mentioned here; #107
  // widened its TLD clause, so that one is no longer outstanding.)
  password: Joi.string().required().messages({
    "string.empty": "Please enter your password",
    "any.required": "Please enter your password",
  }),
};

export default loginSchema;
